import { DefaultService } from '@/services/DefaultService';

export default class VendasRelJustificativaNaoVendaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    getJustificationNoSales(filtros) {
        return this._http.post(`${this._env}/report-sales/justify-no-sale`, filtros, this._headers)
                    .then(res => res.body, this.handleError);
    }

    setStartCSVReport(filtros) {
        return this._http.post(`${this._env}/report-sales/justify-no-sale/csv/start`, filtros, this._headers)
                    .then( res => res.body, this.handleError);
    }
    getCSVReport(filtros) {
        return this._http.post(`${this._env}/report-sales/justify-no-sale/csv`, filtros, this._headers)
                    .then( res => res.body, this.handleError);
    }

    find(id) {
        return this._http.get(`${this._env}/report-sales/justify-no-sale/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    getClienteDetalhesInfo(id) {
        return this._http.get(`${this._env}/report-sales/justify-no-sale/details/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    
}